<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">
<polygon fill="currentColor" points="5.024,11 9.088,14.974 13.025,11 "/>
<path fill="currentColor" d="M7.117,7.615L7.523,9h1.662L6.942,2.399H5.243L3,9h1.662l0.396-1.385H7.117z M6.084,4.104l0.655,2.219H5.437
	L6.084,4.104z"/>
<path fill="currentColor" d="M12.232,7.615c-0.295,0-0.508,0.027-0.508,0.027V7.624c0,0,0.222-0.193,0.508-0.6l2.558-3.628V2.399H9.805
	v1.385h2.428c0.296,0,0.508-0.027,0.508-0.027v0.019c0,0-0.222,0.193-0.508,0.6L9.685,7.984V9h5.151V7.615H12.232z"/>
</svg>
